import React from 'react';
import FeeTypesEnum from '../Enums/FeeTypesEnum';

export class selectHelper {
  static generateSelectValues(base) {
    const result = [];
    base.forEach((b) => result.push({ label: b, value: b, disabled: false }));
    return result;
  }

  // The label a select shows for a value: the label of the option that holds it, or the value itself when no option
  // does. Values are compared as text, because a select hands numbers back as strings.
  static getOptionLabel(options, value) {
    const option = options.find((candidate) => String(candidate.value) === String(value));
    if (option) {
      return option.label;
    }
    return value === null || value === undefined ? '' : String(value);
  }

  static generateOptions(optionValues) {
    const options = [];
    optionValues.forEach((o) =>
      options.push(
        <option
          value={o.value}
          disabled={o.disabled}
          key={`key${o.value}`}
        >
          {o.label} ELEMENTS/PAGE
        </option>
      )
    );
    return options;
  }

  static getTimeZoneOptions() {
    return [
      { label: '(GMT-12:00) International Date Line West', value: -720, disabled: false },
      { label: '(GMT-11:00) Midway Island, Samoa', value: -660, disabled: false },
      { label: '(GMT-10:00) Hawaii', value: -600, disabled: false },
      { label: '(GMT-9:00) Alaska', value: -540, disabled: false },
      { label: '(GMT-8:00) Pacific Time (US & Canada)', value: -480, disabled: false },
      { label: '(GMT-7:00) Mountain Time (US & Canada)', value: -420, disabled: false },
      { label: '(GMT-6:00) Central Time (US & Canada)', value: -360, disabled: false },
      { label: '(GMT-5:00) Eastern Time (US & Canada)', value: -300, disabled: false },
      { label: '(GMT-4:00) Atlantic Time (Canada)', value: -240, disabled: false },
      { label: '(GMT-3:30) Newfoundland', value: -210, disabled: false },
      { label: '(GMT-3:00) Greenland', value: -180, disabled: false },
      { label: '(GMT-2:00) Mid-Atlantic', value: -120, disabled: false },
      { label: '(GMT-1:00) Cape Verde Is. ', value: -60, disabled: false },
      { label: '(GMT) Greenwich', value: 0, disabled: false },
      { label: '(GMT+1:00) Central Europe', value: 60, disabled: false },
      { label: '(GMT+2:00) Cairo, Jerusalem, Kyiv, Sofia', value: 120, disabled: false },
      { label: '(GMT+3:00) Baghdad, Moscow, St. Petersburg', value: 180, disabled: false },
      { label: '(GMT+3:30) Tehran', value: 210, disabled: false },
      { label: '(GMT+4:00) Abu Dhabi, Muscat', value: 240, disabled: false },
      { label: '(GMT+4:30) Kabul', value: 270, disabled: false },
      { label: '(GMT+5:30) Chennia, Kolkata, Mumbai, New Delhi', value: 330, disabled: false },
      { label: '(GMT+5:45) Kathmandu', value: 345, disabled: false },
      { label: '(GMT+6:00) Almaty, Novosibirsk', value: 360, disabled: false },
      { label: '(GMT+6:30) Yangon (Rangoon)', value: 390, disabled: false },
      { label: '(GMT+7:00) Bangkok, Hanoi, Jakarta', value: 420, disabled: false },
      { label: '(GMT+8:00) Beijing, Chongqing, Hong Kong', value: 480, disabled: false },
      { label: '(GMT+9:00) Osaka, Sapporo, Seul, Tokyo', value: 540, disabled: false },
      { label: '(GMT+9:30) Adelaide', value: 570, disabled: false },
      { label: '(GMT+10:00) Brisbane, Melbourne, Sydney', value: 600, disabled: false },
      { label: '(GMT+11:00) Magadan, Solomon Is.', value: 660, disabled: false },
      { label: '(GMT+12:00) Auckland, Fiji, Wellington', value: 720, disabled: false },
      { label: "(GMT+13:00) Nuku'alofa", value: 780, disabled: false },
    ];
  }

  static getSelectOptionsForFeeType(freelanceUser) {
    const selectValues = [{ label: 'Choose a Fee Type..', value: '', disabled: false }];

    if (freelanceUser.IsRM) {
      selectValues.push({ label: FeeTypesEnum.Resource, value: FeeTypesEnum.Resource, disabled: false });
    }
    if (freelanceUser.IsDQ) {
      selectValues.push({ label: FeeTypesEnum.DataQuality, value: FeeTypesEnum.DataQuality, disabled: false });
    }
    if (freelanceUser.IsKAM) {
      selectValues.push({ label: FeeTypesEnum.KAM, value: FeeTypesEnum.KAM, disabled: false });
    }
    if (freelanceUser.IsBD) {
      selectValues.push({ label: FeeTypesEnum.BD, value: FeeTypesEnum.BD, disabled: false });
    }
    if (freelanceUser.IsBI) {
      selectValues.push({ label: FeeTypesEnum.BI, value: FeeTypesEnum.BI, disabled: false });
    }
    if (freelanceUser.IsIT) {
      selectValues.push({ label: FeeTypesEnum.IT, value: FeeTypesEnum.IT, disabled: false });
    }
    if (freelanceUser.IsHR) {
      selectValues.push({ label: FeeTypesEnum.HR, value: FeeTypesEnum.HR, disabled: false });
    }
    if (freelanceUser.IsMarketing) {
      selectValues.push({ label: FeeTypesEnum.Marketing, value: FeeTypesEnum.Marketing, disabled: false });
    }
    if (freelanceUser.IsFinance) {
      selectValues.push({ label: FeeTypesEnum.Finance, value: FeeTypesEnum.Finance, disabled: false });
    }
    if (freelanceUser.IsFieldworkPartner) {
      selectValues.push({
        label: FeeTypesEnum.FieldworkPartner,
        value: FeeTypesEnum.FieldworkPartner,
        disabled: false,
      });
    }

    return selectValues;
  }

  static getSelectOptionsVideoCaseTypeCode() {
    const selectValues = [];

    selectValues.push({ label: 'None', value: 0, disabled: false });
    selectValues.push({ label: 'Single', value: 1, disabled: false });
    selectValues.push({ label: 'Double', value: 2, disabled: false });

    return selectValues;
  }
}

export default selectHelper;
